export default "__VITE_ASSET__4cc5f585__"